
import { Vue, Component, Prop } from "vue-property-decorator";
import { SmartSVG, SVGLibraryCustom, LinkLogic, SmartText } from "_components";

import { ThemeLink } from "_types";

@Component({
  name: "HomeHeroAlternativeMainButton",
  components: { SmartSVG, LinkLogic, SmartText },
})
export default class HomeHeroAlternativeMainButton extends Vue {
  @Prop() link!: ThemeLink;

  rootClass = "c-home-hero-alternative-main-button";
  icon = SVGLibraryCustom.PQArrowRightBreadcrumbs;
}
